module.exports = __webpack_public_path__ + "assets/img/11_471_big.aaa6114d.jpg";